import React, { Component } from "react";
import JobDetails from "../components/dashboard/jobseeker/JobDetails";
import { connect } from "react-redux";
import store from "../store";
import { getPostArchiveView } from "../actions/employerAction";
import { applyJob } from "../actions/jobseekerAction";
import { setRedirectionLink } from "../actions/accountAction";
import { translate } from "react-multi-lang";
import axios from "axios";
// import ServerSetting from "../../config.json";
import ServerSetting from "../config.json";

let environment =
  typeof process.env.NODE_ENV !== "undefined" &&
    process.env.NODE_ENV === "production"
    ? "production"
    : "development";
let API_SERVER = ServerSetting[environment].API_SERVER;


class NCSJobDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            job: null, // State to hold the job data
        };
    }

    componentDidMount() {
        // Retrieve the job data from localStorage
        const jobData = localStorage.getItem("jobDetails");

        if (jobData) {
            // Parse the stored string back into an object and update state
            this.setState({ job: JSON.parse(jobData) });
        }
    }
    // componentDidMount() {
    //     if (this.props.routeParams.jobId) {
    //         store.dispatch(getPostArchiveView({ job_id: this.props.routeParams.jobId }))
    //     }
    //     document.title = this.props.t('header.job_details', { param: 'react' })
    // }

    // setRedirectForHomeUser = () => {
    //     if (this.props.actionReducer.Loginuser &&
    //         this.props.actionReducer.Loginuser.user_type &&
    //         this.props.actionReducer.Loginuser.user_type === '1') {
    //         this.props.router.push(`/job-details/${this.props.routeParams.jobId}`)
    //     } else {
    //         store.dispatch(setRedirectionLink(`job-details/${this.props.routeParams.jobId}`))
    //         this.props.router.push('/signin')
    //     }
    // }

    componentWillUnmount() {
        // store.dispatch(setSearchResults([]));
        localStorage.removeItem("jobDetails");
    }

    applyForJob = async () => {
        await store.dispatch(applyJob({ job_id: this.props.routeParams.jobId }));
        this.props.router.push("/myaccount");
    };
    formatDate(inputDate) {
        let date = new Date(inputDate);
        let day = String(date.getDate()).padStart(2, "0"); // Ensure day is two digits
        let month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure month is two digits
        let year = date.getFullYear(); // Get the full year

        return `${day}-${month}-${year}`;
    }

    submitapplycountncs = async (ncsdata) => {
      const headers = {
        "Content-Type": "application/json",
      };
  
      this.setState({ loading: true });
  
      const apiUrl = API_SERVER + "ncs-state-vacancy-data/apply";
  
      let payloaddata = {
        job_id: ncsdata?.JobID,
        user_id: this?.props?.location?.query?.user_id ? this?.props?.location?.query?.user_id :"",
        job_title: ncsdata?.JobTitle,
      };
  
      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers,
          body: JSON.stringify(payloaddata), // Convert the payload to JSON string
        });
  
        const data = await response.json();
  
        // Check if the response indicates success
        if (data?.success) {
          window.open(ncsdata?.VacancyURL, "_blank");
        }
  
        this.setState({
          // You can handle any results or further state management here
          loading: false,
        });
  
      } catch (error) {
        console.error("Error fetching data:", error);
  
        this.setState({
          error: "Error fetching data from the API",
          loading: false,
        });
      }
  };
    

    render() {
        const { job } = this.state;
       

        return (
            <section
                className="back-dashboard widget-sidebar-context mt-3"
                id="my-sidebar-context"
            >
                <div className="container">
                    <div className="row">
                        <main className="col second-side ps-4 pb-3 h-100">
                            {/* <div className="clearfix"></div>
                            {this.props.EmployerReducer.postArchive  ?
                                <JobDetails
                                    jobData={this.props.EmployerReducer.postArchive}
                                    submit={this.applyForJob}
                                    isNotSubmit={true}
                                    apply={this.setRedirectForHomeUser}
                                /> : <h4>{this.props.t('JobPost.notFound', { param: 'react' })}</h4>} */}

              <div className="col-md-12">
                <div className="tab-content">
                  <div className="panel-heading">Apply (Job data sourced from National Career Service (NCS) portal for enhanced employment opportunities)</div>
                  <div className="panel-body">
                    <div className="right-sidebar p-3 mb-3">
                      <div className="company-name">
                        Name Of Post: {job?.JobTitle}
                      </div>
                      <div className="pt-1 company-name2 pb-2 mb-0 ">
                        {" "}
                        Name Of Employer: {job?.EmployerName}
                      </div>

                      <div className="jobDetailsBox">
                        {" "}
                        <span className="jobDetailsBoxTitle">
                          Place Of Posting :
                        </span>{" "}
                        <span className="jobDetailsBoxTitleValue">
                          {/* All Over India */}
                          {job?.StateName}
                        </span>{" "}
                      </div>

                      <div className="jobDetailsBox">
                        {" "}
                        <span className="jobDetailsBoxTitle">
                          Required Qualification:
                        </span>{" "}
                        <span className="jobDetailsBoxTitleValue">
                          {job?.Qualificationsss}
                        </span>{" "}
                      </div>
                      
                      <div className="jobDetailsBox">
                        {" "}
                        <span className="jobDetailsBoxTitle">
                          Salary(in INR):
                        </span>{" "}
                        <span className="jobDetailsBoxTitleValue">
                          {job &&
                          job.MinimumWages != null &&
                          job.MaximunWages != null
                            ? `${job.MinimumWages || 0} - ${
                                job.MaximunWages || 0
                              }`
                            : job?.MinimumWages || 0}
                          (Monthly)
                        </span>{" "}
                      </div>

                      <div className="jobDetailsBox">
                        {" "}
                        <span className="jobDetailsBoxTitle">
                        Industry :
                        </span>{" "}
                        <span className="jobDetailsBoxTitleValue">
                          {job?.IndustryName}
                        </span>{" "}
                      </div>

                      <div className="jobDetailsBox">
                        {" "}
                        <span className="jobDetailsBoxTitle">
                        Role :
                        </span>{" "}
                        <span className="jobDetailsBoxTitleValue">
                          {job?.FunctionalRoleName}
                        </span>{" "}
                      </div>


                      <div className="jobDetailsBox">
                        {" "}
                        <span className="jobDetailsBoxTitle">
                        SKills :
                        </span>{" "}
                        <span className="jobDetailsBoxTitleValue">
                          {job?.Skills}
                        </span>{" "}
                      </div>


                      <div class="w-100 pt-2">
                        <span class="pe-3 date-clr">
                          Vacancies:{" "}
                          <span className="text-black">
                            {job?.NumberofOpenings}
                          </span>
                        </span>
                        <span class="pe-3 date-clr">
                          Maximum Age(in years):{" "}
                          <span className="text-black">35</span>
                        </span>
                        <span class="pe-3 date-clr">
                          Total Exp. :{" "}
                          <span className="text-black">Fresher </span>
                        </span>
                        <span class="pe-3 date-clr">
                          Gender:<span className="text-black"> Both </span>
                        </span>
                      </div>

                      <div class="row w-100 pt-4">
                        <div class="pull-end text-end w-100">
                          <span class="disabled-color me-3">
                            Posted by: Employer
                          </span>
                          <span class="me-3 disabled-color">
                            Posted on {this.formatDate(job?.PostedDate)}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="right-sidebar p-3 mb-3">
                      <div className="border-bottom pb-3 company-name">
                        Job Description
                      </div>
                      {/* <p className="pt-3">{job?.JobDescription}</p> */}
                      <div className="pt-3" dangerouslySetInnerHTML={{ __html: job?.JobDescription }} />
                    </div>
                  </div>
                </div>
              </div>

              {/* <button
                className="btn btn-primary btn-primary2 mt-2 ml-auto btn-center"
                onClick={() => {
                  window.open(job?.VacancyURL, "_blank");
                }}
              >
                Apply
              </button> */}
                            <div
                                className="button-container"
                                style={{ display: "flex", justifyContent: "center" }}
                            >
                                <button aria-label="Apply"
                                    className="btn btn-primary btn-primary2 mt-2 ml-auto btn-center"
                                    onClick={() => {
                                        // window.open(job?.VacancyURL, "_blank");
                                        this.submitapplycountncs(job)
                                    }}
                                >
                                    Apply
                                </button>
                            </div>
                        </main>
                    </div>
                </div>
            </section>
        );
    }
}

// const mapStateToProps = store => {
//     return store;
// };
// export default connect(mapStateToProps)(translate(NCSJobDetail));
export default NCSJobDetail;
